// extracted by mini-css-extract-plugin
export default {"container":"BulkNotificationPage_container__8zAJ6","heading":"BulkNotificationPage_heading__PQIFL"};